import { Avatar, Box, Button, Typography, alpha, useTheme } from "@mui/material";
import { IMarketplace } from "../../../../interfaces/IMarketplace";
import { Palette } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { CorInput } from "../../../../../core/components/CorInput";
import { ReferenciaImagemMarketplace } from "../../../../enum/ReferenciaImagemMarketplace";
import { SecaoConfiguracao } from "../../../../../core/components/SecaoConfiguracao";

interface PersonalizacaoMarketplaceProps {
    marketplace: IMarketplace
}

export const PersonalizacaoMarketplacePaper = ({ marketplace }: PersonalizacaoMarketplaceProps) => {
    const navigate = useNavigate();
    const theme = useTheme();

    const imagens = marketplace.configuracao?.personalizacao?.imagens;

    const logoUrl = imagens?.find(imagem => imagem.referencia == ReferenciaImagemMarketplace.logo)?.url;
    const capaUrl = imagens?.find(imagem => imagem.referencia == ReferenciaImagemMarketplace.capa)?.url;

    const corPrimaria = marketplace.configuracao?.personalizacao?.corPrimaria ?? theme.palette.primary.main;
    const corSecundaria = marketplace.configuracao?.personalizacao?.corSecundaria ?? theme.palette.secondary.main;

    return (
        <SecaoConfiguracao
            titulo="Personalização"
            descricao="Identidade visual aplicada ao cardápio"
            icone={<Palette />}
            corIcone={corPrimaria}
            acoes={
                <Button
                    size="small"
                    variant="outlined"
                    onClick={() => navigate(`/marketplace/personalizar/${marketplace.uuid}`)}
                    endIcon={<Palette />}
                >
                    Personalizar
                </Button>
            }
        >
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <Box
                    sx={{
                        borderRadius: "12px",
                        overflow: "hidden",
                        border: `1px solid ${theme.palette.divider}`
                    }}
                >
                    <Box
                        sx={{
                            height: 72,
                            backgroundImage: capaUrl ? `url(${capaUrl})` : undefined,
                            background: capaUrl
                                ? undefined
                                : `linear-gradient(120deg, ${alpha(corPrimaria, 0.85)}, ${alpha(corSecundaria, 0.75)})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center"
                        }}
                    />
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, p: 1.5 }}>
                        {logoUrl ? (
                            <Box
                                component="img"
                                src={logoUrl}
                                alt={marketplace.configuracao?.nomePublico}
                                sx={{
                                    width: 56,
                                    height: 56,
                                    mt: "-2rem",
                                    objectFit: "contain",
                                    borderRadius: "12px",
                                    border: `3px solid ${theme.palette.background.paper}`,
                                    backgroundColor: theme.palette.background.paper
                                }}
                            />
                        ) : (
                            <Avatar
                                sx={{
                                    width: 56,
                                    height: 56,
                                    mt: "-2rem",
                                    border: `3px solid ${theme.palette.background.paper}`
                                }}
                            >
                                {marketplace.configuracao?.nomePublico?.charAt(0)?.toUpperCase() || '?'}
                            </Avatar>
                        )}
                        <Box sx={{ minWidth: 0 }}>
                            <Typography variant="body2" fontWeight={600} noWrap>
                                {marketplace.configuracao?.nomePublico}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                                {capaUrl ? "Capa e logo configuradas" : "Capa não configurada"}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                <CorInput
                    cor={corPrimaria}
                    label="Cor primária"
                    mensagemCopiar="Cor primária copiada com sucesso"
                />
                <CorInput
                    cor={corSecundaria}
                    label="Cor secundária"
                    mensagemCopiar="Cor secundária copiada com sucesso"
                />
            </Box>
        </SecaoConfiguracao>
    );
}
